import React, { useEffect, useRef, useState } from 'react';
import EmailEditor, { EditorRef, EmailEditorProps } from 'react-email-editor';
import { usePubSub } from './hooks/PubSubContext';

function HtmlEditor(props) {

    const { name, onchange, currValue } = props;

    const emailEditorRef = useRef(null);
    const { publish, subscribe, unSubscribe } = usePubSub();

    const options = {
        locale: 'es-ES',
        tabs: {
            content: {
                enabled: true,
            },
            blocks: {
                enabled: false,
            }
        },
        features: {
            devTab: false,
        },
    };

    const handleOpen = (ev) => {
        ev.preventDefault();
        publish('openFullModal', {
            showClose: false,
            buttons: [
                { label: 'Cancel', onclick: handleCancel },
                { label: 'ok', onclick: handleSave }
            ],
            contents: [{ content: <div className='email-editor'><EmailEditor ref={emailEditorRef} onReady={onReady} options={options} /></div> }]
        });
    }

    const handleCancel = (ev) => {
        console.log('cnacelled', ev);
        publish('openFullModal', null);
    }

    const handleSave = (ev) => {
        const unlayer = emailEditorRef.current?.editor;
        unlayer?.exportHtml((data) => {
            const { design, html } = data;
            console.log('josn', design);

            onchange(name, html);
            onchange(`${name}_json`, JSON.stringify(design));
            publish('openFullModal', null);
        });
    }

    const onReady = (unlayer) => {
        if (currValue && currValue !== '') {
            unlayer.loadDesign({
                html: currValue,
                classic: false,
            });
        }
        // editor is ready
        // you can load your template here;
        // the design json can be obtained by calling
        // unlayer.loadDesign(callback) or unlayer.exportHtml(callback)

        // const templateJson = { DESIGN JSON GOES HERE };
        // unlayer.loadDesign(templateJson);
    };

    return (
        <div>
            <div>
                <button onClick={handleOpen}>Edit HTML</button>
            </div>
        </div>
    );
}

export default HtmlEditor;